module.exports = __webpack_public_path__ + "img/incense.eb9535ca.jpeg";